import React from 'react';
import M from 'materialize-css';
import { Redirect, Link } from 'react-router-dom';

import NavBarLateral from '../NavBarLateral/index';

class AdminImagenBannerUnidad extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            isLogged: this.props.auth,
        };
    }

    componentWillMount(){
        M.AutoInit();
        M.updateTextFields();
    }

    render(){
        if(this.state.isLogged === true){
            return(
                <div>
                    <NavBarLateral />
                    <div className={`pad`}>
                        <NavTitulo />
                        <div className={`container row`}>
                            <Formulario />
                        </div>
                    </div>
                </div>
            );
        }
        else {
            return <Redirect to="/administrador/login"/>
        }
    }
}

class Formulario extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            file: null,
            adminExitoso: false,
            adminError: false,
            descripcion: '',
            validateForm: false,
            validateUrl: false,
            disabled: 'enabled',
            _id1: '',
            url1: '',
            img1: '',
        };
        this.onFormSubmitOne = this.onFormSubmitOne.bind(this);
        this.handleError = this.handleError.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    componentWillMount(){
        fetch('/api/uip/imagenes/banner/unidad', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json' 
            }
        })
            .then(response => response.json())
            .then(response => {
                this.setState({ _id1: response[0]._id })
            })
            .catch(response => console.log(response))
    }

    onChange(e) {
        this.setState({ file: e.target.files[0] });
    }

    onFormSubmitOne(e){
        e.preventDefault();
        if(this.state.file === null){
            this.handleError();
        }
        else {
            const formData = new FormData();
            formData.append('miProyecto', this.state.file);
            fetch('/api/uip/imagenes/banner/unidad/' + this.state._id1, {
                method: 'PUT',
                body: formData,
            })
                .then(() => {
                    this.setState({
                        adminExitoso: true,
                        descripcion: 'Se actualiza la imagen',
                    })
                })
                .catch(err => this.handleError(err))
        }
    }

    handleError(){
        this.setState({
            adminError: true,
            descripcion: 'No fue posible actualizar la imagen'
        })
    }

    render(){

        if(this.state.adminError === true){
            return(
                <Redirect 
                    to={{
                        pathname: '/administrador/error/general',
                        state: { 
                            descripcionError: this.state.descripcion,
                            rutaRegreso: '/administrador/equipo' 
                        }
                    }}
                />
           );
        }

        if(this.state.adminExitoso === true){
            return(
                <Redirect 
                    to={{
                        pathname: '/administrador/proceso/exitoso',
                        state: { 
                            descripcionError: this.state.descripcion,
                            rutaRegreso: '/administrador/equipo' 
                        }
                    }}
                />
           );
        }

        return(
            <div>
                <form 
                    className="col s12" 
                    onSubmit={this.onFormSubmitOne}
                    autoComplete="off">
                    <br />
                    <div className="row">
                        <h5>Actualizar Imagen Banner - Unidad</h5>
                    </div>
                    <div className="row">
                        <div className="input-field col s12">
                            <i className="large material-icons prefix">apps</i>
                            <input 
                                disabled
                                placeholder="titulo" 
                                id="input_text" 
                                type="text" 
                                data-length="10" 
                                name="id"
                                value={this.state._id1} 
                                />
                            <label 
                                className="active" 
                                htmlFor="input_text">
                                _id de la imagen
                            </label>
                        </div>
                    </div>
                    <div className={`row`}>
                        <div className="file-field input-field col s12">
                            <i className="large material-icons prefix">cloud_upload</i>
                            <input
                                id="fileInput" 
                                type="file" 
                                name="miProyecto"
                                onChange= {this.onChange}/>
                            <input 
                                id="fileInput"
                                className="file-path validate" 
                                name="miProyecto" 
                                onChange={this.onChange}/>
                            <span 
                                class="helper-text right-align">
                                cargar una imagen
                            </span>
                        </div>
                    </div>
                    <div className={`row s12 right-align`}>
                        <button 
                            className={`btn waves-effect waves-light ${this.state.disabled}`} 
                            type="submit">
                            <i class="material-icons left">save</i>
                            Guardar
                        </button>
                    </div>
                    <div className={`row s12 right-align`}>
                        <Link to="/administrador/equipo">
                            <button 
                                className="btn waves-effect waves-light light-blue" 
                                type="submit">
                                <i class="material-icons left">keyboard_return</i>
                                Regresar
                            </button>
                        </Link>
                    </div>
                    <br />
                </form>
            </div>
           
        );
    }
}

class NavTitulo extends React.Component{
    render(){
        return(
            <div className="navbar-fixed">
                <nav className="light-blue">
                    <div className="nav-wrapper">
                        <a className="brand-logo margin-titulo-especiales"
                           href="javascript:void(0);">
                                La Unidad
                                <span 
                                    className="new badge red lighten-1 margin-badge-nav"
                                    data-badge-caption="sección la unidad">
                                    {this.props.cantidad}
                                </span>
                        </a>
                    </div>
                </nav>
            </div>
         
        );
    }
}

export default AdminImagenBannerUnidad;